export default "__VITE_ASSET__BgYmrGsv__"